import React, { useState } from 'react';
import { LEGEND_ITEMS } from '../../constants';

interface LegendProps {
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
  className?: string;
  showToggle?: boolean;
}

const Legend: React.FC<LegendProps> = ({ className = '' }) => {
  const [isCollapsed, setIsLegendCollapsed] = useState<boolean>(true);

  const onToggleCollapse = () => {
    setIsLegendCollapsed(!isCollapsed);
  };

  return (
    <div
      className={`flex flex-col bg-white fixed z-10 right-0 bottom-0 justify-between items-start p-2.5 shadow-lg transition-transform duration-300 ease-in-out ${
        isCollapsed ? 'translate-y-[calc(100%-40px)]' : 'translate-y-0'
      } ${className}`}>
      {onToggleCollapse && (
        <div
          className={`cursor-pointer ${isCollapsed ? 'mb-2.5' : 'mb-0'}`}
          onClick={onToggleCollapse}>
          {isCollapsed ? 'Show' : 'Hide'} Legend
        </div>
      )}
      {LEGEND_ITEMS.map((item) => (
        <div key={item.label} className="flex items-center">
          <div
            className={`w-3 h-3 rounded-full mr-2 text-blue-950`}
            style={{ backgroundColor: item.color }}
          />
          <span className="text-blue-950">{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default Legend;
